import { Button, Card, message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import Heading from "../../../components/Heading";
import "./style.scss";
import NormalAPI from "../../../api";
import urls from "../../../api/urls";
import { capitalize } from "../../../utils";
import { getPacketingGuideFromCplist } from "../../../actionsMethods/masterMethods";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { DeleteOutlined } from "@ant-design/icons";
import API from "../../../api";

function HubCpLinking() {
  const dispatch = useDispatch();
  const { Option } = Select;
  const { GET_HUB_LISTS, PATCH_CP_ALLOCATION, HUB_TO_CP_MASTER_FOR_BAGGING, HUB_TO_CP_LINKING_REMOVE, NEW_GET_CP_LIST } = urls;

  const getFromCpListResponse = useSelector(
    (state) => state?.masterReducer?.getPacketingGuideFromCplistReducer,
    shallowEqual
  );
  const { result } = getFromCpListResponse;
  const allCps = result?.data || [];
  let getRols = JSON.parse(localStorage.getItem("userinfo"));
  const role = getRols?.roles[0]?.replace(/.*_/, "");

  const [hubListDropdown, setHubListDropdown] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState("");
  const [cpListData, setCpListData] = useState([]);
  const [allCPList, setAllCPList] = useState([]);
  const [HubName, setHubName] = useState("");
  const [selectedCPs, setSelectedCPs] = useState([]);

  useEffect(() => {
    getHubLists();
    getCpList();
  }, []);

  useEffect(() => {
    const userName = localStorage.getItem("userId");
    if (userName) {
      let name = JSON.parse(userName);
      setHubName(name?.premises?.premiseName);
    }
  }, []);

  useEffect(() => {
    if (allCps?.length) {
      setCpListData(allCps);
    }
  }, [allCps]);

  useEffect(() => {
    if (HubName && hubListDropdown.length) {
      const matchedHub = hubListDropdown.find(
        (hub) => hub?.label?.toLowerCase() === HubName?.toLowerCase()
      );
      if (matchedHub) {
        getHubCPList(matchedHub?.value);
      }
    }
  }, [HubName, hubListDropdown]);

  const getHubLists = async () => {
    let response = await NormalAPI.Api(GET_HUB_LISTS).getWithHeader();
    if (response?.status) {
      let temp = response?.response?.data?.map((val) => ({
        label: capitalize(val?.premiseName),
        value: val?.premiseId,
      }));
      setHubListDropdown(temp);
    } else {
      setHubListDropdown([]);
    }
  };

  const getCpList = async () => {
    const response = await NormalAPI.Api(NEW_GET_CP_LIST).getWithHeader();
  
    if (response?.status) {
      const temp = response.response.data.map(item => ({
        premiseId: item.premiseId,
        premiseName: capitalize(item.premiseName),
      }));
  
      setAllCPList(temp);
    } else {
      setAllCPList([]);
    }
  };

  const selectHubHandle = (value) => {
    getHubCPList(value);
  };
  const getHubCPList = (key) => {
    dispatch(getPacketingGuideFromCplist(key));
    setSelectedHubs(key);
  };
  const handleCPSelection = (selectedValues) => {
    const selectedCPs = allCPList?.filter((cp) => selectedValues?.includes(cp.premiseId));
    setSelectedCPs(selectedCPs);
  };

  const confirmDelete = (cpId) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Do you really want to remove this CP?",
      okText: "Yes, Delete",
      cancelText: "Cancel",
      onOk: () => showDeleteConfirm(cpId),
    });
  };
  const showDeleteConfirm = async (id) => {
    let res = await API.Api(`${HUB_TO_CP_LINKING_REMOVE}${selectedHubs}?CP-ID=${id}`).patchCustomHeader();

    if (res?.status) {
      unlinkCP(id);
      getHubCPList(selectedHubs);
      message.success(res?.response?.data[0]?.message);
    } else {
      message.error(res?.response?.data[0]?.message);
    }
  };
  const saveCp = async () => {
    let cpPayload = {
      cpId: selectedCPs?.map((item) => item?.premiseId),
    };

    let res = await API.Api(`${PATCH_CP_ALLOCATION}${selectedHubs}`).patchCustomHeader(cpPayload);

    if (res?.status) {
      assingCPToHubMaster();
      getHubCPList(selectedHubs);
      setSelectedCPs([]);

      if (res?.response?.data[0]?.message !== "") {
        message.warning(res?.response?.data[0]?.message);
      }
      if (res?.response?.data[0]?.errorMessage !== "") {
        message.warning(res?.response?.data[0]?.errorMessage);
      }
    } else {
      message.error(res?.response?.data?.message);
    }
  };

  const assingCPToHubMaster = async () => {
    let data = {
      premiseId: +selectedHubs,
      cpIds: selectedCPs?.map((item) => item?.premiseId),
    };
    try {
      let res = await API.Api(HUB_TO_CP_MASTER_FOR_BAGGING).postWithHeader(data);
      if (res?.response?.status === 200) {
        console.log(res?.response?.data?.message);
      }
    } catch (err) {
      console.log(err?.response?.data?.message || "Something went wrong");
    }
  };
  const unlinkCP = async (cpId) => {
    let data = {
      premiseId: +selectedHubs,
      cpIds: [cpId],
    };
    try {
      let res = await API.Api(HUB_TO_CP_MASTER_FOR_BAGGING).deleteIdHeader(data);
      if (res?.response?.status === 200) {
        // message.success(res?.response?.data?.message);
        console.log(res?.response?.data?.message);
      }
    } catch (err) {
      message.error(err?.response?.data?.message);
    }
  };
  return (
    <Card className="hub-cp-container">
      <Heading title="Hub to CP Linking" />
      <div className="hub-cp-layout">
        <div className="hub-section">
          <div className="hub-name">
            <strong>Hub Name:</strong>
            <Select
              style={{ width: "100%" }}
              showSearch
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.includes(input?.toLowerCase())
              }
              placeholder="Select Hub Name"
              value={selectedHubs}
              onChange={(value) => selectHubHandle(value)}
              disabled={role === "HUBADMIN"}
            >
              {hubListDropdown?.map((hubs) => (
                <Option key={hubs?.value} value={hubs?.value}>
                  {hubs?.label}
                </Option>
              ))}
            </Select>
          </div>
          <Card title="CP Linked to Hub" className="cp-card">
            <p className="comma-separated-list">
              {cpListData.length > 0 ? (
                cpListData.map((value) => (
                  <div key={value?.cpId} className="pincode-item">
                    {value?.cpName}
                    <DeleteOutlined
                      onClick={() => confirmDelete(value?.cpId)}
                      className="delete-icon"
                    />
                  </div>
                ))
              ) : (
                "No CPs available"
              )}
            </p>
          </Card>
        </div>
        <div className="channel-partner-section">
          <div className="channel-partner">
            <strong>Channel Partner:</strong>
            <Select
              style={{ width: "100%" }}
              showSearch
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.includes(input?.toLowerCase())
              }
              placeholder="Select CP Name"
              mode="multiple"
              // value={selectedCPs.map((cp) => cp?.premiseId)}
              onChange={handleCPSelection}
            >
              {allCPList?.map((cps) => (
                <Option key={cps.premiseId} value={cps?.premiseId}>
                  {cps.premiseName}
                </Option>
              ))}
            </Select>
            <div className="button-group">
              {/* <Button onClick={() => clearSelection()}>Clear</Button> */}
              <Button type="primary" onClick={() => saveCp()} disabled={!selectedCPs || selectedCPs.length === 0}>Save</Button>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default HubCpLinking;
